import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatDecimal } from '@bingads-webui-campaign/recommendation-core';
import { templateSetupConvPerformance } from '@bingads-webui-campaign/recommendation-inline-setup-conversion-tracking-view';

export class PerformanceSummaryColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    super({
      name: 'PerformanceSummary',
      property: 'PerformanceSummary',
      title: i18n.getString('Details_View_Performance_Summary') || 'Performance summary',
      bodyClasses: ['grid-column-performanceSummary'],
      colClasses: ['col-superLongText'],
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({
    value: {
      NumClicks,
      NumImpressions,
    },
  }) {
    const { i18n } = this;

    return templateSetupConvPerformance({
      numClicks: formatDecimal(NumClicks, i18n),
      numImpressions: formatDecimal(NumImpressions, i18n),
      i18n,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
